/** Copy any SUNTRONIX ITAM reference/document number to the clipboard in the
 *  global SUNTRONIX format: rich text/html (Verdana 12pt Bold) + a clean
 *  text/plain fallback that is ONLY the exact reference (no labels, quotes,
 *  brackets or extra text). Returns true on success. Never reads the clipboard.
 *
 *  This is the single source of truth for reference-number copy behaviour used
 *  by the <STXReferenceNumber/> component and any future module. */
export async function copyReference(reference) {
  const plain = String(reference || "").trim();
  if (!plain) return false;
  const html =
    `<span style="font-family: Verdana, Arial, sans-serif; font-size: 12pt; font-weight: 700;">${plain}</span>`;

  // Preferred: rich clipboard (text/html + text/plain) via ClipboardItem.
  try {
    if (navigator.clipboard && typeof window.ClipboardItem !== "undefined") {
      const item = new window.ClipboardItem({
        "text/html": new Blob([html], { type: "text/html" }),
        "text/plain": new Blob([plain], { type: "text/plain" }),
      });
      await navigator.clipboard.write([item]);
      return true;
    }
  } catch (e) {
    // fall through to plain-text write
  }

  // Fallback 1: plain-text clipboard (exact reference only).
  try {
    if (navigator.clipboard && navigator.clipboard.writeText) {
      await navigator.clipboard.writeText(plain);
      return true;
    }
  } catch (e) {
    // fall through to legacy execCommand
  }

  // Fallback 2 (legacy / insecure context): hidden textarea + execCommand.
  try {
    const ta = document.createElement("textarea");
    ta.value = plain;
    ta.style.position = "fixed";
    ta.style.top = "-1000px";
    ta.style.opacity = "0";
    document.body.appendChild(ta);
    ta.focus();
    ta.select();
    const ok = document.execCommand("copy");
    document.body.removeChild(ta);
    return ok;
  } catch (e) {
    return false;
  }
}

export default copyReference;
